<div _ngcontent-ng-c2133802427="" style="width: 26.15vw; position: fixed">
<div _ngcontent-ng-c2133802427="" class="card">
<!-- -->
<div _ngcontent-ng-c2133802427="" class="accordion-body" id="live-Streaming">
<!-- -->
</div>
<div _ngcontent-ng-c2133802427="" class="card-header">
<strong _ngcontent-ng-c2133802427="" style="position: relative; top: 0.5px">Open Bets</strong>
</div>
<div _ngcontent-ng-c2133802427=""><!-- --></div>
</div>
</div>